import Link from "@Generic/navigation/Link";
import {useClickBannerEvent} from "@Events/hooks/useClickBannerEvent";
import TransfersVehicleType
    from "@SearchResults/features/banners/features/getByTransferBanner/types/TransfersVehicle.type";
import VehicleSnippetFooter from "./VehicleSnippetFooter";
import VehicleSnippetHeader from "./VehicleSnippetHeader";
import VehicleSnippetBadge from "./VehicleSnippetBadge";

interface GetByTransferVehicleSnippetProps {
    vehicleData: TransfersVehicleType
}

function VehicleSnippet({vehicleData}: GetByTransferVehicleSnippetProps) {
    const {
        link: redirectUrl,
        imageUrl,
        vehicleGroupName,
        maxNumberOfPassengers,
        price,
        vehicleGroupId,
    } = vehicleData

    const bannerClicked = useClickBannerEvent({
        bannerType: 'snippet',
        bannerName: "transfer",
        bannerLink: redirectUrl,
        bannerVehicleType: null,
        bannerPrice: price,
        bannerIntegrationFlag: !!price
    })

    return (
        <div
            className="gb--vehicle-card"
            onClick={() => {
                window.open(redirectUrl, '_blank');
                bannerClicked()
            }}
        >
            <VehicleSnippetBadge
                vehicleGroupId={vehicleGroupId}
            />
            <VehicleSnippetHeader
                vehicleGroupName={vehicleGroupName}
                imageUrl={imageUrl}
            />
            <VehicleSnippetFooter
                maxNumberOfPassengers={maxNumberOfPassengers}
                price={price}
            />
        </div>
    )
}

export default VehicleSnippet